/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import slate from './core/slate'
import node from './core/node'
import base from './core/base'
import utils from './helpers/utils'

export const Slatebox = { slate, node, base, utils }
